import React from 'react'
import Remisiones from '../components/Remisiones'

const remisiones = () => {
  return (
    <Remisiones />
  )
}

export default remisiones